import React from 'react';
import { CardType } from '../../../../../types/commonPropTypes';

const PaddingCard: React.FC<CardType> = ({ children }: CardType) => {
  return <div className="padding-card">{children}</div>;
};

export default PaddingCard;
